import { createTag } from '@frontend/api-client/utils';
import type { BaseApi } from '@frontend/api-client/utils/types';
import type { ListLetterRecommendationsResponse, RetrieveLetterRecommendationResponse } from '@frontend/api-types';
import { convertArrayObjectKeysCase, convertObjectKeysCase } from '@frontend/duck-tape';
import LETTER_RECOMMENDATION_ENDPOINTS from './endpoint';

export const getLetterRecommendationsApi = (baseApi: BaseApi) =>
  baseApi.injectEndpoints({
    endpoints: (builder) => ({
      listLetterRecommendations: builder.query<ListLetterRecommendationsResponse, void>({
        providesTags: [createTag({ id: 'LIST', type: 'LetterRecommendation' })],
        query: LETTER_RECOMMENDATION_ENDPOINTS.listLetterRecommendations,
        transformResponse: (response: GenericRecord[]) =>
          convertArrayObjectKeysCase(response, 'camelCase') as ListLetterRecommendationsResponse,
      }),
      markLetterRecommendationAsViewed: builder.mutation<void, string>({
        invalidatesTags: (_result, _error, id) => [
          createTag({ id, prefix: 'letterRecommendationId', type: 'LetterRecommendation' }),
          createTag({ id: 'LIST', type: 'LetterRecommendation' }),
        ],
        query: (id) => ({
          method: 'POST',
          url: LETTER_RECOMMENDATION_ENDPOINTS.markLetterAsViewed(id),
        }),
      }),
      retrieveLetterRecommendation: builder.query<RetrieveLetterRecommendationResponse, string>({
        providesTags: (_result, _error, id) => [
          createTag({ id, prefix: 'letterRecommendationId', type: 'LetterRecommendation' }),
        ],
        query: (id) => ({
          url: LETTER_RECOMMENDATION_ENDPOINTS.retrieveLetterRecommendation(id),
        }),
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as RetrieveLetterRecommendationResponse,
      }),
    }),
    overrideExisting: true,
  });
